import { useLingui } from "@lingui/react";
import { WIcon } from "@mobility-item-page/client";
import { Button } from "@warp-ds/elements/react/button";

interface MinimizedModalProps {
  dealerName: string;
  maximize: () => void;
  close: () => void;
}

export const MinimizedModal = ({ dealerName, maximize, close }: MinimizedModalProps) => {
  const { i18n } = useLingui();
  return (
    // biome-ignore lint/a11y/useSemanticElements: Cannot use <button> because it contains a nested <Button> (close), which would be invalid HTML
    <div
      className="fixed bottom-0 right-48 z-50 flex w-[360] h-48 items-center justify-center gap-8 rounded-t-8 s-bg-primary shadow-m pl-16 pr-4 py-4 cursor-pointer"
      onClick={maximize}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          maximize();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={i18n.t({
        id: "dealer.contactForm.messageTo.label",
        message: "Message to {dealerName}",
        values: { dealerName },
      })}
    >
      <h1 className="t4 mb-0 w-full whitespace-nowrap overflow-hidden text-ellipsis s-text-inverted">
        {i18n.t({
          id: "dealer.contactForm.messageTo.label",
          message: "Message to {dealerName}",
          values: { dealerName },
        })}
      </h1>
      <h1 className="t4 font-normal mb-0 whitespace-nowrap s-text-inverted">{`(${i18n.t({ id: "dealer.contactForm.draft.label", message: "draft" })})`}</h1>
      <div className="flex items-center justify-center">
        <span className="flex items-center px-10 rounded-8 py-[7px] hover:s-bg-primary-hover">
          <WIcon name="Expand" className="s-text-inverted" />
        </span>
        <Button
          variant="utilityQuiet"
          small
          className="part-[base]:px-10 hover:part-[base]:s-bg-primary-hover"
          onClick={(e) => {
            e.stopPropagation();
            close();
          }}
        >
          <WIcon name="Close" className="s-text-inverted" />
        </Button>
      </div>
    </div>
  );
};
